var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16.03C.88.03.562.098.33.33c-.232.233-.3.55-.3.83v14.676c0 .28.068.588.3.82.233.232.55.309.83.309h5.08a.566.566 0 0 0 .404-.967.565.565 0 0 0-.404-.162H1.16V1.159h14.676v5.08a.565.565 0 1 0 1.129 0V1.16c0-.28-.068-.596-.3-.829-.233-.232-.55-.3-.83-.3H1.16zm7.902 7.903a1.14 1.14 0 0 0-1.129 1.129v14.676a1.14 1.14 0 0 0 1.129 1.13h14.676a1.14 1.14 0 0 0 1.13-1.13V9.062a1.14 1.14 0 0 0-1.13-1.129H9.062zm0 1.129h14.676v14.676H9.062V9.062z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fa8c0030be8f75f89ef1908d511843c1.svg";
export { ForwardRef as ReactComponent };